import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Box, Group, Image, NumberFormatter, Progress, Text, rem } from '@mantine/core';
import type { PropsWithChildren } from 'react';
import classes from '../Shares/Progress.module.css';
export type UserInfoCardProps = PropsWithChildren & {
  username: string;
  verifyLevel: number;
  level: number;
  expStart: number;
  expEnd: number;
};
export const UserInfoCard: React.FC<UserInfoCardProps> = ({
  username,
  verifyLevel,
  level,
  expStart,
  expEnd,
  children
}) => {
  const {
    i18n
  } = useLingui();
  return <Box bg="var(--navbar-bg-color)" mt={{
    base: 16,
    sm: 20
  }} p={{
    base: 10,
    sm: 20
  }} style={{
    borderRadius: rem(5)
  }}>
      <Group justify="space-between">
        <Box>
          <Text fz={{
          base: 14,
          sm: 18
        }} className={gunterzBold.className}>
            {username}
          </Text>
          <Text fz={13} fw={700} c="var(--icon-color)" tt="uppercase">
            {i18n._('VERIFIED LVL {verifyLevel}', {
            verifyLevel
          })}
          </Text>
        </Box>
        <Box>
          <Text fz={{
          base: 14,
          sm: 18
        }} className={gunterzBold.className} ta="right" tt="uppercase">
            {i18n._('PRIMEORB')}
          </Text>
          <Text fz={13} fw={700} c="var(--text-prime)" ta="right" tt="uppercase">
            {i18n._('LEVEL {level}', {
            level
          })}
          </Text>
        </Box>
      </Group>

      <Box pt={60}>
        <Group justify="space-between">
          <Text fz={{
          base: 12,
          sm: 13
        }} c="var(--text-prime)" fw={700}>
            <NumberFormatter value={expStart} thousandSeparator="," decimalSeparator="." />
          </Text>
          <Text fz={{
          base: 12,
          sm: 13
        }} c="var(--icon-color)" fw={700}>
            <NumberFormatter value={expEnd} thousandSeparator="," decimalSeparator="." />
          </Text>
        </Group>

        <Box bg="dark.13" h={27} p={0} mt={10} pos="relative" style={{
        borderRadius: rem(5)
      }}>
          <Image src="/assets/info/avatar.png" w={{
          base: 128,
          sm: 165
        }} h={{
          base: 109,
          sm: 140
        }} mx="auto" pos="absolute" bottom={27} left={0} right={0} style={{
          zIndex: 10
        }} alt="avatar" />
          <Group h="100%" px={16}>
            <Box pos="relative" w="100%">
              <Progress radius={0} size="md" value={expStart / expEnd * 100} striped classNames={{
              root: classes.root,
              section: classes.sectionOne
            }} style={{
              zIndex: 1
            }} />
              <Progress radius={0} size="md" value={100} striped classNames={{
              root: classes.root,
              section: classes.sectionSecond
            }} pos="absolute" inset={0} />
            </Box>
          </Group>
        </Box>

        <Group mt={10} justify="end">
          <Text c="var(--icon-color)" fz={{
          base: 12,
          sm: 13
        }} fw={700} tt="uppercase">
            {i18n._('NEXT: LEVEL {verifyLevel}', {
            verifyLevel
          })}
          </Text>
        </Group>

        {children}
      </Box>
    </Box>;
};